<template>
  <div class="live-center-container" v-if="liveEvents.length >0">
    <v-expansion-panels :multiple="true" v-model="activePanels" >
      <v-expansion-panel
      >
        <v-expansion-panel-header expand-icon="krypt-arrow-down" v-if="!isMobileOrTablet"
        >
          <div class="live-center">
            <span>{{$t('liveCenter.liveCenter')}}</span>
          </div>

        </v-expansion-panel-header>
        <!--        <v-expansion-panel-header expand-icon="krypt-arrow-down"-->
        <!--                                  v-if="selectedTournament !=='none'">-->
        <!--          <span style="margin-right:8px;">{{tournament.title}}</span>-->
        <!--        </v-expansion-panel-header>-->
        <v-expansion-panel-content>
          <!-- v-bind:class="{'lmt-loader':currentView === 'lmt',
                        'video-loader':currentView === 'video',
                        'statistics-loader':currentView === 'statistics'}"> -->
          <div v-if="!isMobileOrTablet">
            <div class="live-center-options">
              <div class="live-center-icons-wrapper">
                <div class="live-center-icons" v-bind:class="{'active-section-icon':currentView==='lmt'}" @click="setCurrentView('lmt',$event)">
                  <v-icon
                    size="24"
                    color="var(--grey-400)"
                  >
                    krypt-field
                  </v-icon>
                </div>
                <!-- v-if="!isMobile"> -->
                <div class="live-center-icons" v-bind:class="{'active-section-icon':currentView==='video'}" @click="setCurrentView('video',$event)">
                  <v-icon
                    size="24"
                    color="var(--grey-400)"
                  >
                    krypt-live-video
                  </v-icon>
                </div>
                <div class="live-center-icons" v-bind:class="{'active-section-icon':currentView==='statistics'}" @click="setCurrentView('statistics',$event)">
                  <v-icon
                    size="24"
                    color="var(--grey-400)"
                  >
                    krypt-stats
                  </v-icon>
                </div>
              </div>
              <div class="live-center-dropdown-wrapper">
                <div @click="showDropdown"
                     v-click-outside:shouldShowDropdown="showDropdown.bind(showDropdown,'shouldShowDropdown')"
                     class="live-center-dropdown">
                  <div class="live-center-dropdown-selection">
                    <div class="live-center-dropdown-icon">
                      <img :src="sportsToIconsMapping[selectedEvent.sportIdentifier]"
                             v-if="typeof selectedEvent !=='undefined'"></img>
                    </div>
                    <div class="live-center-dropdown-text"
                         v-if="typeof selectedEvent !=='undefined'">
                      <span>{{selectedEvent.homeTeam}} &ndash; {{selectedEvent.awayTeam}}</span>
                    </div>
                  </div>
                  <div
                    v-bind:class="{'live-center-dropdown-dropdown-arrow-open':dropdowns.shouldShowDropdown}"
                    class="live-center-dropdown-dropdown-arrow">
                    <v-icon>
                      krypt-arrow-down
                    </v-icon>
                  </div>
                </div>
                <div class="live-center-dropdown-anchor">
                  <div v-bind:class="{'live-center-dropdown-absolute-open':dropdowns.shouldShowDropdown}"
                       class="live-center-dropdown-absolute">
                    <div v-bind:class="{'live-center-dropdown-contents-open':dropdowns.shouldShowDropdown}"
                         class="live-center-dropdown-contents">

                      <div v-for="event in liveEvents"
                           class="live-center-dropdown-item"
                           @click="selectEventForLiveCenter(event)">
                        <div class="live-center-dropdown-item-selection">
                          <div class="live-center-dropdown-item-icon">
                            <img :src="sportsToIconsMapping[event.sportIdentifier]"></img>
                          </div>
                          <div class="live-center-dropdown-item-text">
                            <span>{{event.homeTeam}} &ndash; {{event.awayTeam}}</span>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="video-live-player loading-animation" v-show="currentView === 'video'">
            <div v-if="!canShowVideo" class="video-live-error">
              <div class="video-live-error-content">
                <div class="video-live-error-icon">
                  <v-icon>krypt-live-video-error</v-icon>
                </div>
                <div class="video-live-error-text">
                  <span>{{videoErrorTranslation}}</span>
                </div>
              </div>
            </div>
            <div v-show="canShowVideo" class="video-wrapper">
              <div id="playerContainer">

              </div>

            </div>
          </div>
          <!-- <div class="empty-lmt-placeholder">
            <v-img :src="EmptyLMTImg" class="empty-page-img" :eager="true"></v-img>
          </div> -->
          <div class="betradar-v2-widget-wrapper-lmt loading-animation" v-show="currentView === 'lmt'">
            <div class="betradar-v2-widget live-center-br-widget betradar-v2-component">

            </div>
          </div>
          <div class="betradar-v2-widget-wrapper-statistics loading-animation" v-show="currentView === 'statistics'">
            <div class="betradar-v2-widget live-center-br-widget-statistics betradar-v2-component">

            </div>
          </div>
        </v-expansion-panel-content>
        <v-expansion-panel-header expand-icon="krypt-arrow-down" v-if="isMobileOrTablet"
                                  @click.stop="" class="mobile-live-center-toolbar">
          <div class="mobile-video-icons">

            <div class="live-center-icons" v-bind:class="{'active-section-icon':currentView==='lmt'}" @click="setCurrentView('lmt',$event)">
              <v-icon
                size="24"
                color="var(--grey-400)"
              >
                krypt-field
              </v-icon>
            </div>
            <!-- v-if="!isMobile"> -->
            <div class="live-center-icons" v-bind:class="{'active-section-icon':currentView==='video'}" @click="setCurrentView('video',$event)">
              <v-icon
                size="24"
                color="var(--grey-400)"
              >
                krypt-live-video
              </v-icon>
            </div>
            <div class="live-center-icons" v-bind:class="{'active-section-icon':currentView==='statistics'}" @click="setCurrentView('statistics',$event)">
              <v-icon
                size="24"
                color="var(--grey-400)"
              >
                krypt-stats
              </v-icon>
            </div>
          </div>
        </v-expansion-panel-header>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>

import CompetitionsList from '@/components/CompetitionsList';
import BasketBallIcon from '../assets/Sports/Basketball.svg';
import SoccerIcon from '../assets/Sports/Soccer.svg';
import TableTennis from '../assets/Sports/Ping-Pong.svg';
import TennisIcon from '../assets/Sports/Tennis.svg';
import CricketIcon from '../assets/Sports/Cricket.svg';
import EmptyLMTImg from '@/assets/utility/LMTPlaceholder.svg';

//Prefetch Image
const EmptyLMTImgObj = new Image();
EmptyLMTImgObj.src = EmptyLMTImg;

//Prefetch iamges
const BasketBallIconObj = new Image();
BasketBallIconObj.src = BasketBallIcon;
const SoccerIconObj = new Image();
SoccerIconObj.src = SoccerIcon;
const TableTennisObj = new Image();
TableTennisObj.src = TableTennis;
const TennisIconObj = new Image();
TennisIconObj.src = TennisIcon;
const CricketIconObj = new Image();
CricketIconObj.src = CricketIcon;

export default {
  name: 'LiveCenter',
  data: function () {
    return {
      showLMTPlaceholder: true,
      activePanels: [0],
      defaultLiveMatch: 'none',
      player: {},
      videoErrorMappings: {
        notLoggedIn: this.$t('errorMessages.videoErrorNotLoggedIn'),
        notEnoughBalance: this.$t('errorMessages.videoErrorNotEnoughBalance'),
        unavailableForCountry: this.$t('errorMessages.videoErrorNotAvailableForCountry'),
        unavailableForDevice: this.$t('errorMessages.videoErrorNotAvailableForDevice'),
        eventHasNoVideo: this.$t('errorMessages.videoErrorNotAvailableForEvent'),
        unavailableForNow: this.$t('errorMessages.videoErrorNotAvailableForThisMoment'),
      },
      EmptyLMTImg: EmptyLMTImgObj.src,
      sportsToIconsMapping: {
        soccer: SoccerIconObj.src,
        tennis: TennisIconObj.src,
        basketball: BasketBallIconObj.src,
        tabletennis: TableTennisObj.src,
        cricket: CricketIconObj.src,
      },
      dropdowns:{
        shouldShowDropdown: false
      },
      _clickOutside:{
        dropdown:null
      }
    };
  },
  watch: {
    canShowVideo: function (canShowVideo) {
      if (canShowVideo === false && typeof this.player !== 'undefined' && typeof this.player.remove !== 'undefined') {
        this.player.remove();
        this.player = undefined;
      }
    },
    liveEvents: function (newEventsList, oldEventsList) {
      if (newEventsList.length === 1 && oldEventsList.length === 0 || (oldEventsList.length > 0 && newEventsList.length > 0 && oldEventsList[0].id !== newEventsList[0].id)) {
        this.$nextTick(function () {
          SIR('addWidget', '.live-center-br-widget', (this.shouldUseLMTLight?'match.lmtLight':'match.lmtPlus'), {
            'matchId': (this.selectedEvent !== 'none' ? this.selectedEvent.remoteId.replace('sr:match:', '') : newEventsList[0].remoteId.replace('sr:match:', '')),
            'scoreboard': 'disable',
            'momentum': 'disable',
            'layout': 'single',
            'disablePitch': false,
            'tabsPosition': 'disable'
          }, this.hideLMTPlaceholder);

        });

      }
    },
    streamMappings: function (mappings) {
      if (this.defaultLiveMatch === 'none') {
        // this.defaultLiveMatch = mappings.find(())
      }
    },
    currentView: function (newView) {
      if (newView === 'video') {
        // this.$nextTick(function () {
        if (this.canShowVideo && typeof this.player !== 'undefined' && typeof this.player.resetVideoSize !== 'undefined') {

          this.$nextTick(function () {
            this.player.playVideo();
            this.player.resetVideoSize();

          }.bind(this));

        } else if (this.canShowVideo && (this.hlsUrl !== 'unset' && this.dashUrl !== 'unset') && (typeof this.player === 'undefined' || typeof this.player.resetVideoSize === 'undefined')) {
          // Set player again
          this.$nextTick(function () {
            this.player = new avvpl.setupPlayer({
              id: 'playerContainer',
              // streamUrl: validUrl,
              // url: this.hlsUrl,
              // autoplay:this.currentView === 'video',
              allowFullScreen: true
            });
            // let validUrl = his.player.canHandleStream(this.hlsUrl) ? this.hlsUrl : this.dashUrl;
            this.player.load(this.player.canHandleStream(this.hlsUrl) ? this.hlsUrl : this.dashUrl);
            this.player.resetVideoSize();

          });

          window.player = this.player;

        }

        // }.bind(this))
      } else {
        if (typeof this.player !== 'undefined' && typeof this.player.stopVideo !== 'undefined') {

          this.player.stopVideo();

        }
      }
      // if (newView === 'lmt') {
      SIR('addWidget', '.live-center-br-widget', (this.shouldUseLMTLight?'match.lmtLight':'match.lmtPlus'), {
        'matchId': (this.selectedEvent !== 'none' ? this.selectedEvent.remoteId.replace('sr:match:', '') : this.liveEvents[0].remoteId.replace('sr:match:', '')),
        'scoreboard': 'disable',
        'momentum': 'disable',
        'layout': 'single',
        'disablePitch': false,
        'tabsPosition': 'disable',
        callback: this.hideLMTPlaceholder

      });

      // }
      // if (newView === 'statistics') {
      SIR('addWidget', '.live-center-br-widget-statistics', 'match.lmtPlus', {
        'matchId': (this.selectedEvent !== 'none' ? this.selectedEvent.remoteId.replace('sr:match:', '') : this.liveEvents[0].remoteId.replace('sr:match:', '')),
        'scoreboard': 'disable',
        'momentum': 'disable',
        'layout': 'topdown',
        'disablePitch': true,
        'tabsPosition': 'top',
        callback: this.hideLMTPlaceholder

      });

      // }
    },
    selectedEvent: {
      // deep: true,
      handler: function (newEvent,oldEvent) {
        try {
            if(typeof newEvent !=='undefined' && typeof oldEvent !=='undefined' && newEvent.id !== oldEvent.id){
              this.$nextTick(function () {
                if (this.currentView === 'lmt') {

                  SIR('addWidget', '.live-center-br-widget', (this.shouldUseLMTLight?'match.lmtLight':'match.lmtPlus'), {
                    'matchId': newEvent.remoteId.replace('sr:match:', ''),
                    'scoreboard': 'disable',
                    'momentum': 'disable',
                    'layout': 'single',
                    'disablePitch': false,
                    'tabsPosition': 'disable',
                    callback: this.hideLMTPlaceholder

                  });
                }
                SIR('addWidget', '.live-center-br-widget-statistics', 'match.lmtPlus', {
                  'matchId': (this.selectedEvent !== 'none' ? this.selectedEvent.remoteId.replace('sr:match:', '') : this.liveEvents[0].remoteId.replace('sr:match:', '')),
                  'scoreboard': 'disable',
                  'momentum': 'disable',
                  'layout': 'topdown',
                  'disablePitch': true,
                  'tabsPosition': 'top',
                  callback: this.hideLMTPlaceholder

                });
              })

            } else if(typeof newEvent !=='undefined' && typeof oldEvent ==='undefined'){
              this.$nextTick(function () {
                if (this.currentView === 'lmt') {

                  SIR('addWidget', '.live-center-br-widget', (this.shouldUseLMTLight?'match.lmtLight':'match.lmtPlus'), {
                    'matchId': newEvent.remoteId.replace('sr:match:', ''),
                    'scoreboard': 'disable',
                    'momentum': 'disable',
                    'layout': 'single',
                    'disablePitch': false,
                    'tabsPosition': 'disable',
                    callback: this.hideLMTPlaceholder

                  });
                }
                SIR('addWidget', '.live-center-br-widget-statistics', 'match.lmtPlus', {
                  'matchId': (this.selectedEvent !== 'none' ? this.selectedEvent.remoteId.replace('sr:match:', '') : this.liveEvents[0].remoteId.replace('sr:match:', '')),
                  'scoreboard': 'disable',
                  'momentum': 'disable',
                  'layout': 'topdown',
                  'disablePitch': true,
                  'tabsPosition': 'top',
                  callback: this.hideLMTPlaceholder

                });
              })

            }



        } catch (e) {
          console.log(e);
        }

      }
    },
    streamId: function (newValue) {
      // this.$nextTick(function () {
      // this.player.loadLivestreams(this.hlsUrl,this.dashUrl)
      console.log('change url');
      // this.player.canHandleStream(this.hlsUrl) ?
      //   this.player._continueLoad(this.hlsUrl) :
      if (this.currentView === 'video') {
        if (this.canShowVideo && (this.hlsUrl !== 'unset' && this.dashUrl !== 'unset')) {
          // this.$nextTick(function () {
          if (typeof this.player !== 'undefined' && typeof this.player !== 'undefined' && typeof this.player.canHandleStream !== 'undefined') {

            // let validUrl = this.player.canHandleStream(this.hlsUrl) ? this.hlsUrl : this.dashUrl;
            this.player.load(this.player.canHandleStream(this.hlsUrl) ? this.hlsUrl : this.dashUrl);
            this.player._continueLoad(this.player.canHandleStream(this.hlsUrl) ? this.hlsUrl : this.dashUrl);
            this.player.resetVideoSize();
            if (this.currentView === 'lmt') {
              this.player.stopVideo();

            }

          } else {

            this.player = new avvpl.setupPlayer({
              id: 'playerContainer',
              // streamUrl: validUrl,
              // url: this.hlsUrl,
              // autoplay:this.currentView === 'video',
              allowFullScreen: true
            });
            // let validUrl = his.player.canHandleStream(this.hlsUrl) ? this.hlsUrl : this.dashUrl;
            this.player.load(this.player.canHandleStream(this.hlsUrl) ? this.hlsUrl : this.dashUrl);
            this.player.resetVideoSize();
            if (this.currentView === 'lmt') {
              this.player.stopVideo();

            }

          }
          window.player = this.player;
          // }.bind(this))

        } else if (typeof this.player !== 'undefined' && typeof this.player.remove !== 'undefined') {
          this.player.remove();
          this.player = undefined;
        }

      }
      // Set player again

      // this.player.reloadPlayer({
      //   id: "playerContainer",
      //   streamUrl:this.hlsUrl,
      //   url:this.hlsUrl,
      //   allowFullScreen:true
      // });
      // this.player._continueLoad(this.hlsUrl);
      //   this.player.updateExternalOverlay()
      // this.player.canHandleStream(this.hlsUrl)? this.player.load(this.hlsUrl):this.player.load(this.dashUrl)

      // }.bind(this))
    }
  },
  computed: {
    shouldUseLMTLight:function(){
      return this.selectedEvent.eventType ==='Match' && this.selectedEvent.sportIdentifier === 'cricket'
    },
    sportListOrder:function(){
      let order = {};
      this.$store.state.navigations.sports.forEach((sport,index) =>{
        order[sport.sportIdentifier] = index
      });
      return order
    },
    isLoggedIn:function(){
      return this.$store.state.user.isLoggedIn;
    },
    hasBalance:function(){
      return this.$store.state.user.info.balance > 0;
    },
    isMobileOrTablet: function () {
      return (this.$store.state.deviceMode === 'mobile-landscape' || this.$store.state.deviceMode === 'mobile-portrait' || this.$store.state.deviceMode === 'tablet');

    },
    marketsGroupedByEvents: function () {
      return this.$store.state.markets;
    },
    isMobile: function () {
      return (this.$store.state.deviceMode === 'mobile-landscape' || this.$store.state.deviceMode === 'mobile-portrait');
    },

    videoErrorTranslation: function () {
      let translation = '';

      if (typeof this.streamMappings[this.selectedEvent.remoteId] === 'undefined') {
        translation = this.videoErrorMappings.eventHasNoVideo;
      } else if (typeof this.streamMappings[this.selectedEvent.remoteId] !== 'undefined' && typeof this.streamMappings[this.selectedEvent.remoteId].reason !== 'undefined') {
        if (this.streamMappings[this.selectedEvent.remoteId].reason === 'Country') {
          translation = this.videoErrorMappings.unavailableForCountry;
        } else {
          translation = this.videoErrorMappings.unavailableForDevice;
        }
      } else if(!this.isLoggedIn) {
        translation = this.videoErrorMappings.notLoggedIn;
      } else if(!this.hasBalance) {
        translation = this.videoErrorMappings.notEnoughBalance;
      } else if (this.errorInStreamInfo !== 'none') {
        translation = this.videoErrorMappings.unavailableForNow;
      } else {
        translation = this.videoErrorMappings.eventHasNoVideo;
      }

      /* changed the order as per the specs - see above
      if(!this.isLoggedIn){
        translation = this.videoErrorMappings.notLoggedIn;
      } else if(!this.hasBalance){
        translation = this.videoErrorMappings.notEnoughBalance;
      }
      else if (this.errorInStreamInfo !== 'none') {
        translation = this.videoErrorMappings.unavailableForNow;
      } else if (typeof this.streamMappings[this.selectedEvent.remoteId] === 'undefined') {
        translation = this.videoErrorMappings.eventHasNoVideo;
      } else if (typeof this.streamMappings[this.selectedEvent.remoteId] !== 'undefined' && typeof this.streamMappings[this.selectedEvent.remoteId].reason !== 'undefined') {
        if (this.streamMappings[this.selectedEvent.remoteId].reason === 'Country') {
          translation = this.videoErrorMappings.unavailableForCountry;
        } else {
          translation = this.videoErrorMappings.unavailableForDevice;

        }
      } else {
        translation = this.videoErrorMappings.eventHasNoVideo;
      }*/

      return translation;
    },
    errorInStreamInfo: function () {
      return this.$store.state.liveCenter.streamInfo.videoError;
    },
    canShowVideo: function () {
      return (typeof this.selectedEvent !== 'undefined' && typeof this.streamMappings[this.selectedEvent.remoteId] !== 'undefined'
        && typeof this.streamMappings[this.selectedEvent.remoteId].reason === 'undefined'
        && this.errorInStreamInfo === 'none'
        && (this.hlsUrl !== 'unavailable'
        || this.dashUrl !== 'unavailable')
      );
    },
    tournamentsList: function () {
      let competitionsArray = [];
      this.$store.state.navigations.sports.forEach((sport) => competitionsArray = competitionsArray.concat(sport.tournaments));
      return competitionsArray;
    },
    eventsWithStreamId: function () {
      return this.$store.state.liveCenter.eventsWithStreamId;
    },
    liveEvents: function () {
      let liveEventList = this.$store.state.events.eventsListLiveFlat;
      liveEventList = liveEventList.map(function (event) {
        let tournamentOfEvent = this.tournamentsList.find(tournament => tournament.id === event.tournamentId);
        event.sportIdentifier = tournamentOfEvent?.sportIdentifier;
        return event;
      }.bind(this))
        .filter(function (event) {
          return typeof this.marketsGroupedByEvents[event.id] !== 'undefined';
        }.bind(this));
      return liveEventList.sort(function (a, b) {
          // let n = a.orderId - b.orderId;
          if(a.sportIdentifier !== b.sportIdentifier){
            return this.sportListOrder[a.sportIdentifier] - this.sportListOrder[b.sportIdentifier]
          } else {
            return new Date(a.start) > new Date(b.start)
          }

      }.bind(this))
    },
    selectedEvent: function () {
      return (this.$store.state.liveCenter.selectedEvent !== 'none' ? this.$store.state.liveCenter.selectedEvent : this.liveEvents[0]);
    },
    currentView: function () {
      return this.$store.state.liveCenter.currentView;
    },
    streamId: function () {
      return this.$store.state.liveCenter.streamInfo.streamId;
    },
    dashUrl: function () {
      return this.$store.state.liveCenter.streamInfo.dashUrl;

    },
    hlsUrl: function () {
      return this.$store.state.liveCenter.streamInfo.hlsUrl;
    },
    streamMappings: function () {
      return this.$store.state.streamMappingsObj;
    }

  },
  methods: {
    selectEventForLiveCenter: function (event) {
      this.shouldShowDropdown = false;
      this.$store.commit('setLiveCenterActiveSection', 'lmt');
      this.$store.commit('setLiveCenterEvent', event);
      if(typeof this.streamMappings[event.remoteId] !=='undefined' && this.streamMappings[event.remoteId].streams !==''){
        this.$store.dispatch('getValidStreamInfo', {
          rid: event.remoteId,
          streamId: this.streamMappings[event.remoteId].streams,
          event: event
        });
      }

    },
    setCurrentView: function (section, event) {
      event.stopPropagation();
      this.$store.commit('setLiveCenterActiveSection', section);
      if ((this.hlsUrl === 'unset' || this.dash === 'unset') && typeof this.streamMappings[this.selectedEvent.remoteId] !=='undefined' && this.streamMappings[this.selectedEvent.remoteId].streams !=='') {
        this.$store.dispatch('getValidStreamInfo',
          {
            rid: (this.selectedEvent !== 'none' ? this.selectedEvent.remoteId : this.liveEvents[0].remoteId),
            streamId: (this.selectedEvent !== 'none' ? this.streamMappings[this.selectedEvent.remoteId].streams : this.liveEvents[0].streamId),
            event: (this.selectedEvent !== 'none' ? this.selectedEvent : this.liveEvents[0])
          });

      }

    },
    showDropdown: function () {
      this.dropdowns.shouldShowDropdown = !this.dropdowns.shouldShowDropdown;`1`
    },
    hideLMTPlaceholder: function () {
      this.showLMTPlaceholder = false;
    }
  },

  mounted: function () {

    if (this.selectedEvent !== 'none' && typeof this.selectedEvent !== 'undefined') {
      SIR('addWidget', '.live-center-br-widget', (this.shouldUseLMTLight?'match.lmtLight':'match.lmtPlus'), {
          'matchId': this.selectedEvent.remoteId.replace('sr:match:', ''),
          'scoreboard': 'disable',
          'momentum': 'disable',
          'layout': 'single',
          'disablePitch': false,
          'tabsPosition': 'disable'
        },
        this.hideLMTPlaceholder);
    } else if (this.liveEvents.length > 0) {
      SIR('addWidget', '.live-center-br-widget', (this.shouldUseLMTLight?'match.lmtLight':'match.lmtPlus'), {
          'matchId': this.liveEvents[0].remoteId.replace('sr:match:', ''),
          'scoreboard': 'disable',
          'momentum': 'disable',
          'layout': 'single',
          'disablePitch': false,
          'tabsPosition': 'disable'
        },
        this.hideLMTPlaceholder);
    }

    // this.player.on('error', function (error) {
    //   console.log(error);
    //   // this.player.stopVideo()
    // }.bind(this));
  },
  directives: {
    clickOutside: {
      componentUpdated: function (el, binding, vnode) {
        setTimeout(() => {
          const handler = (e) => {
            if (!el.contains(e.target) && el !== e.target && vnode.context.$data.dropdowns[binding.arg]) {
              binding.value(e);
            }
          };
          if (vnode.context.$data.dropdowns[binding.arg]) {
            if (vnode.context.$data._clickOutside[binding.arg] == null) {
              vnode.context.$data._clickOutside[binding.arg] = handler;
              document.addEventListener('click', vnode.context.$data._clickOutside[binding.arg]);
            }
          } else {
            document.removeEventListener('click', vnode.context.$data._clickOutside[binding.arg]);
            vnode.context.$data._clickOutside[binding.arg] = null;
          }
        }, 100);
      },
      unbind: function (el, binding, vnode) {
        document.removeEventListener('click', vnode.context.$data._clickOutside[binding.arg]);
        vnode.context.$data._clickOutside[binding.arg] = null;
      }
    }
  }
};
</script>
<style scoped>
  .mobile-live-center-toolbar {
    background: white;
    border-top: 1px solid var(--grey-200) !important;
  }

  .active-section-icon > .krypt{
    color: var(--primary)!important;
  }

  #playerContainer {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .live-center-options {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 8px;
    background-color: var(--grey-100);
  }

  .live-center > span {
    font-size: 14px;
    line-height: 19px;
    font-weight: 700;
    color: var(--grey-900);
  }

  .live-center-icons {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 4px;
    padding-right: 4px;
    width: 100%;
  }

  .live-center-icons i:hover {
    color: var(--grey-600) !important;
    cursor: pointer;
  }

  .live-center-icons-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
  }

  .live-center-dropdown-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
    padding: 0 8px;
    flex-direction: column;
  }

  .live-center-dropdown {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--grey-300);
    border-radius: 4px;
    width: 100%;
    cursor: pointer;
    background-color: var(--grey-100);
  }

  .live-center-dropdown-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin: 0 4px;
  }

  .live-center-dropdown-text {
    display: flex;
    padding: 8px 0;
    user-select: none;
    overflow: hidden;
  }

  .live-center-dropdown-text > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 15.5em;
  }

  .live-center-dropdown-selection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .live-center-dropdown-dropdown-arrow, .live-center-dropdown-dropdown-arrow > i {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
  }

  .live-center-dropdown-dropdown-arrow {
    margin-right: 4px;
    margin-left: 8px;
  }

  .live-center-dropdown-dropdown-arrow > i {
    font-size: 16px;
    color: var(--grey-900);
  }

  .live-center-dropdown-dropdown-arrow-open > i {
    transform: rotateZ(-180deg);
  }

  .live-center-dropdown-anchor {
    position: relative;
    width: 100%;
  }

  .live-center-dropdown-absolute {
    position: absolute;
    width: 100%;
    z-index: 10;
    top: 4px;
    transition: padding-top 0s 0.4s;
    background: white;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19);
  }

  .live-center-dropdown-absolute-open{
    top: 4px;
    border-radius: 4px;
    overflow: hidden;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-right: 2px;
    transition: padding-top 0s;
  }

   .live-center-dropdown-contents::-webkit-scrollbar {
     width: 8px;
     background: #f0f0f0;
     /* disabling to make it look like on Firefox
     border-radius: 4px;
     margin-bottom: 4px; */
   }

   .live-center-dropdown-contents::-webkit-scrollbar-thumb {
     background: #c1c1c1;
     /* disabling to make it look like on Firefox
     border-radius: 4px; */
   }

   .live-center-dropdown-contents::-webkit-scrollbar-thumb:hover {
     background: #a6a6a6;
     /* disabling to make it look like on Firefox
     border-radius: 4px; */
   }

  .live-center-dropdown-contents {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    max-height: 0;
    width: 100%;
    overflow: hidden;
    flex-direction: column;
    transition: max-height 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);
    /* border-radius: 4px; */
    /*border: white 1px solid;*/
    background: white;
    scrollbar-width: thin;
  }



  .live-center-dropdown-contents-open {
    overflow-x: hidden !important;
    overflow-y: auto !important;
    max-height: 300px;
  }

  /* not needed because it is now inside another container
  .live-center-dropdown-contents:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .live-center-dropdown-contents:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  } */

  .live-center-dropdown-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    transition: background-color 0.25s ease-in-out;
  }

  .live-center-dropdown-item:hover {
    background: var(--grey-200);
    cursor: pointer;
  }

  .live-center-dropdown-item-selection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .live-center-dropdown-item-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin: 0 4px;
  }

  .live-center-dropdown-item-text {
    display: flex;
    padding: 8px 0;
    user-select: none;
    padding-right: 8px;
  }

  .live-center-dropdown-item-text > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800);
  }

  .video-live-error {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: var(--grey-800);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
  }

  .video-live-error-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: 100%;
  }

  .video-live-error-icon {
    width: 80px;
    height: 80px;
  }

  .video-live-error-icon > i {
    width: 80px;
    height: 80px;
  }

  .video-live-error-icon > i:before {
    font-size: 80px !important;
    color: var(--grey-300);
  }

  .video-live-error-text{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 8px 8px;
  }

  .video-live-error-text > span {
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    font-weight: 700;
    color: var(--grey-400);
  }

  .video-live-player {
    display: flex;
    justify-content: center;
    align-content: center;
    position: relative;
    /* z-index: 2; */
    width: 100%;
    padding-top: 56.11%;
    max-width: 500px;
  }

  .video-wrapper {
    background-color: #111;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 2;
  }

  .betradar-v2-widget-wrapper-lmt {
    position: relative;
    width: 100%;
    padding-top: 61.97%;
    max-width: 500px;
    overflow: hidden;
  }

  .betradar-v2-widget-wrapper-statistics {
    position: relative;
    width: 100%;
    padding-top: calc(61.97% + 32px);
    max-width: 500px;
  }
  @media screen and (max-width: 1279px) {
    .betradar-v2-widget-wrapper-lmt {
      padding: 0;
      height: 62.25vw; /* 61.97vw; */
      max-height: 309.85px;
      left: 50%;
      transform: translateX(-50%);
    }

    .betradar-v2-widget-wrapper-statistics {
      padding: 0;
      height: calc(62.25vw + 32px);
      max-height: 341.85px;
      left: 50%;
      transform: translateX(-50%);
    }

    .video-live-player {
      padding: 0;
      height: 56.11vw;
      max-height: 280.56px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  @media screen and (max-width: 500px) {
    .betradar-v2-widget-wrapper-lmt {
      height: 61.97vw;
    }

    .betradar-v2-widget-wrapper-statistics {
      height: calc(61.97vw + 32px);
    }
  }

  /* .video-live-player,
  .betradar-v2-widget-wrapper-lmt,
  .betradar-v2-widget-wrapper-statistics {
    background-color: var(--grey-300);
  } */

  /*.video-live-player::after,
  .betradar-v2-widget-wrapper-lmt::after,
  .betradar-v2-widget-wrapper-statistics::after { */
  .loading-animation {
    background-color: var(--grey-300);
    overflow: hidden;
  }

  .loading-animation::after {
    background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .3), hsla(0, 0%, 100%, 0));
    /* -webkit-animation: loading 1.5s infinite;
    animation: loading 1.5s infinite; */
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);
    z-index: 1;
  }

  .betradar-v2-widget {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 2;
  }

  .empty-lmt-placeholder {
    display: flex;
    position: absolute;
    width: 100%;
    z-index: 0;
    height: calc(100% - 42px);
  }

  .empty-lmt-placeholder > >>> .v-image:after {
    background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .3), hsla(0, 0%, 100%, 0));
    /* -webkit-animation: loading 1.5s infinite;
    animation: loading 1.5s infinite; */
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);
    z-index: 1;
  }

  .live-center-container {
    width: 100%;
    /* border-bottom: 1px solid var(--grey-200); */
  }

  @media screen and (min-width: 1280px) {
    .live-center-container {
      border-bottom: 1px solid var(--grey-200);
    }
  }

  .mobile-video-icons {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 24px;
  }

   .betradar-v2-widget-wrapper{
     height: 100%;
   }

  /* useless now
  .betradar-v2-widget{
    margin-left: auto;
    margin-right: auto;
    max-width: 530px;
    position: relative;
    top: 50%;
    fotransrm: translateY(-50%);
  } */

   .lmt-loader {
     height: calc(61.9vw - (0px * 0.619));
     max-height: 360px;
   }

   .video-loader {
     height: calc(56.25vw - (0px * 0.5625));
     max-height: 360px;
   }

   .statistics-loader {
     min-height: 200px;
     max-height: 360px;
   }
    .v-expansion-panel::before{
      box-shadow: none;
    }
  /*Vuetify*/

   @media screen and (min-width: 1280px) {
    >>> .v-expansion-panel{
      box-shadow: none !important;
      background-color: var(--grey-100) !important;
    }
   }

   >>> .v-expansion-panel-content__wrap{
     background-color: var(--grey-100) !important;
   }

  >>> .v-expansion-panel-content__wrap {
    padding: 0px;
  }

  >>> .v-expansion-panel-header {
    padding: 8px !important;
    min-height: unset !important;
  }

  >>> .v-expansion-panel-header::before {
    opacity: 0 !important;
  }

  >>> .v-expansion-panel-content {
    position: relative;
  }

  >>> .v-expansion-panel-header__icon{
    margin-left: 8px !important;
    margin-top: 0;
    margin-bottom: 0;
  }

  /*Media Queries*/

  @media screen and (max-width: 1279px) {
    .empty-lmt-placeholder {
      height: 100%;
    }

    .live-center-container {
      margin-top: -8px;
    }
    .v-expansion-panel{
      border-radius: 0px!important;
    }

    .betradar-v2-widget-wrapper{
      position: relative;
      background-color: white;
    }

  }

  @media screen and (min-width: 1280px) {
    .lmt-loader {
      height: 224px;
    }

    .video-loader {
      height: 202px;
    }

    .statistics-loader {
      height: 256px;
    }
  }

  /*Animations*/

  @-webkit-keyframes loading {
    to {
      transform: translateX(100%)
    }
  }

  @keyframes loading {
    to {
      transform: translateX(100%)
    }
  }

</style>

